<template>
  <a href="#" class="back-to-top" v-scroll-to="{ el:selector, offset: -200 }">
    <span class="back-to-top__span">Back to top</span>
    <fa-icon class="back-to-top__icon" icon="chevron-up"></fa-icon>
  </a>
</template>

<script type="text/javascript">
export default {
  data() {
    return {}
  },
  props: ['selector']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import "nib"

.back-to-top
  row()
  clickable()
  disableDefaultLink()
  white-space nowrap
  align-items center
  padding 10px
  &__span
    font-family "Open Sans", sans-serif
    font-weight 600
    color #018478
  &__icon
    square(20px)
    color #6e6e6e
    margin-left 10px

</style>